module.exports = __webpack_public_path__ + "img/Icon-Engineering.152fb3c4.svg";